import { useState } from 'react';
import type { Incident, IncidentGroup } from '../../services/incidentsApi';

export function useIncidentDrawerState() {
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedIncident, setSelectedIncident] = useState<Incident | null>(null);
  const [selectedGroupContext, setSelectedGroupContext] = useState<IncidentGroup | null>(null);
  const [viewDialogTab, setViewDialogTab] = useState(0);
  const [drawerAdvancedOpen, setDrawerAdvancedOpen] = useState(false);

  return {
    viewDialogOpen,
    setViewDialogOpen,
    selectedIncident,
    setSelectedIncident,
    selectedGroupContext,
    setSelectedGroupContext,
    viewDialogTab,
    setViewDialogTab,
    drawerAdvancedOpen,
    setDrawerAdvancedOpen,
  };
}
